import { render } from "./EditCompanyRules.vue?vue&type=template&id=7ed76981"
import script from "./EditCompanyRules.vue?vue&type=script&lang=js"
export * from "./EditCompanyRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__